import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Role, User } from '../_models';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  userSubject: BehaviorSubject<User>;
  user: Observable<User>;
  roles = Role;

  constructor(private http: HttpClient, private router: Router) {
    this.userSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('user'))
    );

    this.user = this.userSubject.asObservable();
  }

  get userValue(): User {
    return this.userSubject.value;
  }

  login(credentials) {
    return this.http
      .post<any>(`${environment.apiUrl}/api/login`, credentials)
      .pipe(
        map((user) => {
          // Store user and token to local storage
          localStorage.setItem('user', JSON.stringify(user));
          this.userSubject.next(user);
          localStorage.setItem('currentUser', JSON.stringify(user.user));
          return user;
        })
      );
  }

  logout() {
    // ! Treba da se testira!
    return this.http.get(`${environment.apiUrl}/api/logout`).pipe(
      map((responseData) => {
        // remove user from local storage to log user out

        localStorage.removeItem('user');
        localStorage.removeItem('currentUser');

        this.userSubject.next(null);
        this.router.navigate(['/login']);
        return responseData;
      })
    );
  }

  isAuthorized(authorizedUsers: string[]): boolean {
    const currentUserRole = Object.keys(this.roles)[
      Object.values(this.roles).indexOf(this.userValue.user?.role_id)
    ];
    if (authorizedUsers.includes(currentUserRole)) {
      return false;
    }
    return true;
  }
}
